import React from "react";

export default function TandC() {
    return (
        <>
            <br /><br /><br /><br />

            <div className="container fb_tandc" style={{ marginBottom: "100px" }}>
                <h2 align="center" className="style6">
                    <strong style={{ fontWeight: "bold" }}>
                        WELCOME TO FAT <i>bastard</i>.
                    </strong>
                </h2>

                <p align="center" className="style6">
                    <strong>
                        WE SUPPORT RESPONSIBLE DRINKING AND OUR WINES ARE NOT FOR SALE TO
                        PERSONS UNDER THE AGE OF 18.
                    </strong>
                </p>

                <p align="center" className="style6">
                    <strong style={{ fontWeight: "bold" }}>
                        “Donkey Long Tong” Giveaway – Online Competition
                    </strong>
                </p>

                <p><strong>Terms and Conditions</strong></p>

                <ol>
                    <li>
                        The competition is open to all residents of South Africa who are
                        aged 18 years or older.
                    </li>

                    <li>
                        The Promoter is <strong style={{ fontWeight: "bold" }}>Robertson Winery (Pty) Ltd</strong>, hereinafter referred to
                        as “the Promoter”.
                    </li>

                    <li>
                        Excluded from entering this competition are employees, directors,
                        members, consultants and partners of the Promoter, its advertising
                        agencies or agents, and their spouses, life partners, immediate
                        family members, business partners or associates.
                    </li>

                    <li>
                        There is <strong style={{ fontWeight: "bold" }}>one (1) prize</strong> to be won by <strong style={{ fontWeight: "bold" }}>one (1) winner</strong>. The prize consists of:
                        <ul>
                            <li><strong style={{ fontWeight: "bold" }}>One Donkey Long Tong Set</strong></li>
                        </ul>
                    </li>

                    <li>The total prize value is <strong style={{ fontWeight: "bold" }}>R6,600.00.</strong></li>

                    <li>
                        The competition runs from 10 June 2026 to 30 June 2026.
                    </li>

                    <li>
                        To enter, participants must purchase at least <strong style={{ fontWeight: "bold" }}>one case </strong> of Wine from the FAT bastard online shop during the Competition Period:
                        <br />
                        <a
                            href="https://shop.fatbastardwine.co.za/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            https://shop.fatbastardwine.co.za
                        </a>
                    </li>

                    <li>
                        Each qualifying purchase counts as <strong style={{ fontWeight: "bold" }}>one (1) entry</strong>. Participants may enter as many times as they like, provided each entry is linked to a separate qualifying purchase.
                    </li>

                    <li>
                        The prize is <strong style={{ fontWeight: "bold" }}>not transferable</strong> and <strong style={{ fontWeight: "bold" }}>may not be exchanged for cash</strong> or
                        any other item. The prize shown in promotional material is not
                        necessarily an exact representation of the prize.
                    </li>

                    <li>
                        One winner will be <strong style={{ fontWeight: "bold" }}>randomly selected</strong> by the Promoter using an
                        automated or audited selection process.
                    </li>

                    <li>
                        The winner will be announced on FAT bastard’s social media channels
                        (including Facebook and Instagram) and/or contacted directly using
                        the details provided at checkout.
                    </li>

                    <li>
                        The winner may be required to provide <strong style={{ fontWeight: "bold" }}>proof of identity</strong> in order to
                        claim the prize and must supply a <strong style={{ fontWeight: "bold" }}>valid South African delivery
                        address</strong> for delivery of the prize.
                    </li>

                    <li>
                        The Promoter will make every reasonable attempt to contact the
                        winner. If the winner cannot be contacted within a reasonable
                        period, the Promoter reserves the right to select an alternative
                        winner.
                    </li>

                    <li>
                        By entering the competition and/or accepting the prize, the winner
                        indemnifies, releases and holds harmless the Promoter and its
                        directors, employees, agents and partners from any and all claims,
                        liability, injury, loss or damage of any kind arising from or in
                        connection with the competition and/or the prize.
                    </li>

                    <li>
                        The Promoter’s decision is final, and no correspondence will be
                        entered into.
                    </li>

                    <li>
                        The Promoter reserves the right to amend, suspend or cancel the
                        competition and/or the prize at any time for any reason deemed
                        necessary.
                    </li>

                    <li>
                        By entering this competition, participants agree that the Promoter
                        and its group of companies may collect, store and use their personal
                        information for the purposes of administering this competition and
                        awarding the prize. Participants further agree that their
                        information may be shared with the Promoter’s promotional partners
                        solely for the purposes of fulfilling the prize.
                    </li>

                    <li>
                        The Promoter will obtain written consent from the winner should the
                        Promoter wish to use the winner’s name, photographs or any
                        competition-related material for unpaid promotional or publicity
                        purposes.
                    </li>

                    <li>
                        The entry instructions form part of these Terms and Conditions. By
                        entering the competition, all participants are deemed to have read,
                        understood and accepted these Terms and Conditions.
                    </li>
                </ol>

                <p><strong style={{ fontWeight: "bold" }}>PROMOTER:</strong> Robertson Winery (Pty) Ltd</p>
            </div>
        </>
    );
}
